import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function School() {
    const history = useHistory()
  return (
    <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",width:"100vw",height:"100vh"}}>
        <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"15vh",marginTop:{xs:"3vh",md:"7vh"},textAlign:"center"}}>
            <Typography variant="h4" color="primary" sx={{maxWidth:"80vw"}}>Astha Hospital Management Service</Typography>
            <Typography variant="p" sx={{maxWidth:"80vw"}}>A hospital management service for refugee patients</Typography>
        </Box>
        <Box sx={{display:"flex",flexDirection:{xs:"column",md:"row"},height:{xs:"90vh",md:"80vh"}}}>
            <Box sx={{width:{xs:"100vw",md:"50vw"},height:{xs:"40vh",md:"80vh"},backgroundImage:`url("https://i.postimg.cc/YqRN4Fyt/front-view-bearded-homeless-man.jpg")`,backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>
                
                <Button variant="contained" sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:{xs:"15vh",md:"15vh"},width:{xs:"65vw",md:"30vw"}}} onClick={()=>history.push('/hospital/HospitalService')}>
                    <Typography sx={{fontSize:13}}>I am a refugee patient </Typography>
                    <Typography variant="h5">I want to get my reports </Typography>
                </Button>
            </Box>
            <Box sx={{width:{xs:"100vw",md:"50vw"},height:{xs:"40vh",md:"80vh"},backgroundImage:`url("https://i.postimg.cc/P5qW1qBY/doctor-nurses-special-equipment.jpg")`,backgroundPosition:"center",display:"flex",flexDirection:{xs:"column",md:"row"},alignItems:"center",justifyContent:"center"}}>
                <Button variant="contained" sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:{xs:"15vh",md:"15vh"},width:{xs:"65vw",md:"30vw"}}} onClick={()=>history.push('/hospital/VerifyHospital')}>
                    <Typography sx={{fontSize:13}}>I am a doctor </Typography>
                    <Typography variant="h5">I want to update a patient info </Typography>
                </Button>
            </Box>
        </Box>
    </Box>
  )
}
